import { ERROR_CODE, Isubject, IteacherInfo, PersonalAccountVO, UserTenant, getTokenTenantId } from '@yuanfudao/metis-unified-login'
import { atom } from 'recoil'
import { useAccount, UNIVERSAL_CONTEXT } from '@yuanfudao/metis-standard-data'

export const userTenantsAtom = atom<UserTenant[]>({
  key: 'tenants',
  default: [],
})

export const currentAccountAtom = atom<PersonalAccountVO | null>({
  key: 'current-account',
  default: null,
})

export const teacherInfoAtom = atom<IteacherInfo | null>({
  key: 'teacher-info',
  default: null,
})

export const teaNameAtom = atom<string>({
  key: 'teacher-name',
  default: '',
})

export const currentSubjectAtom = atom<Isubject | null>({
  key: 'current-subject',
  default: null,
})

export function useTeacherInfo() {
  const { updateAccount, updateUserTenants: updateUserTenantsFn } = useAccount()

  const updateTeacherInfo = async () => {
    try {
      const curTid = getTokenTenantId()
      const inTenantId = curTid ? String(curTid) : ''
      // const infoData = getDecodedToken() as AccessToken
      // const { tid: inTenantId } = infoData
      console.log('curTid inTenantId', curTid, inTenantId)
      if (inTenantId && inTenantId !== '-1') {
        await updateAccount(UNIVERSAL_CONTEXT.ACCOUNT)
        const res = await updateAccount(UNIVERSAL_CONTEXT.TEACHER)
        return res
      }
      // return new Error('inTenantId === -1 错误')
      console.log('inTenantId === -1 未选择学校')
      return null
    } catch (e: any) {
      if (e?.response?.status === 403 || [ERROR_CODE.NO_PERMISSION, ERROR_CODE.NO_PERMISSION2].includes(e?.response?.data?.code)) {
        return e.response
      }
      console.warn(e)
      console.log('updateTeacherInfo 错误')
      // return new Error('updateTeacherInfo 错误')
      return null
    }
  }

  const updateUserTenants = async () => {
    try {
      const result = await updateUserTenantsFn()
      return result

    } catch (e: any) {
      const { code } = e.cause
      if ([ERROR_CODE.NO_PERMISSION, ERROR_CODE.NO_PERMISSION2].includes(code as ERROR_CODE)) {
        return code
      }
      if (e?.response?.status === 403 || [ERROR_CODE.NO_PERMISSION, ERROR_CODE.NO_PERMISSION2].includes(e?.response?.data?.code)) {
        return e.response
      }
      console.warn(e)
      return new Error('updateRoles 错误')
    }
  }
  const updateTotalTeacherInfo = async () => {
    const res = await Promise.all([
      updateUserTenants(),
      updateTeacherInfo(),
    ])
    return {
      userTenants: res[0],
      teacherInfo: res[1],
    }
  }
  return {
    updateUserTenants,
    updateTeacherInfo,
    updateTotalTeacherInfo,
  }
}
